module.exports = __webpack_public_path__ + "img/battery_icon_table.eb07265c.svg";